<template>
  <filter-summary
    icon="item"
    title="商品分類"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
    >{{ count }}{{ label }}</filter-summary
  >
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,

    selectMode: {
      type: String,
    },

    category: {
      type: Object,
      default: () => ({
        categories: [],
      }),
    },
    item: {
      type: Object,
      default: () => ({
        categories: [],
        items: [],
        itemGroupId: undefined,
      }),
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    count() {
      if (this.selectMode === 'category') {
        return this.category.categories.length
      } else if (this.selectMode === 'itemCategory') {
        return this.item.categories.length
      } else if (this.selectMode === 'item') {
        if (this.item.itemGroupId) {
          return undefined
        } else {
          return this.item.items.length
        }
      }
      return undefined
    },
    label() {
      if (this.selectMode === 'category') {
        return '分類'
      } else if (this.selectMode === 'itemCategory') {
        return '商品(分類指定)'
      } else if (this.selectMode === 'item') {
        if (this.item.itemGroupId) {
          return '選択商品'
        } else {
          return '商品(商品指定)'
        }
      }
      return undefined
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
